import {updateObject} from '@/store/utils'
import {ACTION_NAME} from '@/constants/add-to-home-screen'
import {cloneDeep} from 'lodash'
import {ModuleFc} from '@/project'
import {UserActionState} from './types'
export {UserActionState}

const initState: UserActionState = {
  actions: [],
  from: '',
  action: '',
  routeFrom: '',
  routeAction: '',
}

const module: ModuleFc<UserActionState> = () => {
  return {
    namespaced: true,
    state: cloneDeep(initState),
    getters: {
      isAddedHomeScreen(state) {
        return state.actions.includes(ACTION_NAME)
      },
    },
    mutations: {
      setActions(state, payload: string) {
        const actions = new Set(state.actions)
        actions.add(payload)
        state.actions = [...actions]
      },
      removeActions(state, payload: string) {
        const actions = new Set(state.actions)
        actions.delete(payload)
        state.actions = [...actions]
      },
      update(state, payload: object) {
        updateObject(state, payload)
      },
    },
  }
}

export default module
